import React from "react";
import { Reducer, ProductStateType, ProductDispatch } from "./reducer";

export const ProductStateContext = React.createContext<ProductStateType>({
  data: [],
});
export const ProductDispatchContext = React.createContext<
  ProductDispatch | undefined
>(undefined);

interface ProductProviderProps {}

type ProductProviderPropsType = React.PropsWithChildren<ProductProviderProps>;

export const ProductProvider: React.FC<ProductProviderPropsType> = ({
  children,
}: ProductProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {
    data: [],
  });
  return (
    <ProductDispatchContext.Provider value={dispatch}>
      <ProductStateContext.Provider value={state}>
        {children}
      </ProductStateContext.Provider>
    </ProductDispatchContext.Provider>
  );
};

export const useProductState = () => {
  const state = React.useContext(ProductStateContext);
  return state;
};

export const useProductDispatch = () => {
  const dispatch = React.useContext(ProductDispatchContext);
  return dispatch;
};
